import axios from "axios";
import { BACKEND_BASE } from "../config/api";

/** Days of news_/gameWords_ collections kept in Firestore and shown in the edition breadcrumb. */
export const DAILY_CONTENT_RETENTION_DAYS = 7;

/** @param {string} dateKey YYYY-MM-DD @param {number} deltaDays */
export function shiftISODate(dateKey, deltaDays) {
  const [y, m, d] = dateKey.split("-").map(Number);
  const utc = Date.UTC(y, m - 1, d + deltaDays);
  const dt = new Date(utc);
  const yy = dt.getUTCFullYear();
  const mm = String(dt.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(dt.getUTCDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
}

/** Newest-first list of edition date keys (today in London plus prior days). */
export function buildArchiveDateKeys(
  londonToday,
  count = DAILY_CONTENT_RETENTION_DAYS
) {
  const keys = [];
  for (let i = 0; i < count; i++) {
    keys.push(shiftISODate(londonToday, -i));
  }
  return keys;
}

export function formatEditionBreadcrumbLabel(dateKey, londonToday) {
  if (dateKey === londonToday) return "Today";
  const yesterday = shiftISODate(londonToday, -1);
  if (dateKey === yesterday) return "Yesterday";
  const [y, m, d] = dateKey.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
  });
}

export function formatEditionLongDate(dateKey) {
  const [y, m, d] = dateKey.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

/**
 * Which day's Firestore collections the app should read.
 * Until the 01:00 London job completes, this is the previous published day.
 */
export async function fetchPublishedContentStatus() {
  const { data } = await axios.get(`${BACKEND_BASE}/daily-content/status`, {
    timeout: 15000,
  });
  return {
    publishedDateKey: data.publishedDateKey,
    londonToday: data.londonToday,
    isTodayLive: Boolean(data.isTodayLive),
    jobStatus: data.jobStatus,
    jobPhase: data.jobPhase,
  };
}

export function collectionNamesForDate(dateKey) {
  return {
    news: `news_${dateKey}`,
    gameWords: `gameWords_${dateKey}`,
  };
}
